<script lang="ts">
	import FormContainer from '$lib/components/form/FormContainer.svelte'
	import FormHeader from '$lib/components/form/FormHeader.svelte'
	import MessengerForm from '$lib/domain/contact/MessengerForm.svelte'
	import CustomQuestionAnswerForm from '$lib/domain/customQuestions/CustomQuestionAnswerForm.svelte'
	import {
		isCustomQuestionRequired,
		isCustomQuestionVisible,
	} from '$lib/domain/customQuestions/customQuestions'
	import {
		type RegistrationForm,
		registrationFormSettingsContextKey,
	} from '$lib/domain/signUp/registrationForm'
	import { _ } from '@repo/i18n'
	import { InputType } from '@repo/ui'
	import { Input } from '@repo/ui'
	import { Select } from '@repo/ui'
	import type { AffiliatesV1AffiliateRegistrationFormSettings } from '@sdk/Api'
	import { getContext } from 'svelte'

	interface Props {
		form: RegistrationForm
	}

	let { form = $bindable() }: Props = $props()

	let formSettings: AffiliatesV1AffiliateRegistrationFormSettings = getContext<{
		getSettings: () => AffiliatesV1AffiliateRegistrationFormSettings
	}>(registrationFormSettingsContextKey).getSettings()
</script>

<FormHeader headline={$_('signUpAffiliate.additionalQuestions.headline')} />

<FormContainer>
	{#if isCustomQuestionVisible(formSettings.telephone)}
		<Input
			name="telephone"
			label={$_('affiliateRegistrationData.telephone')}
			max={20}
			required={isCustomQuestionRequired(formSettings.telephone)}
			type={InputType.tel}
			bind:value={form.affiliate.data.telephone}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.messenger)}
		<MessengerForm
			required={isCustomQuestionRequired(formSettings.messenger)}
			bind:messenger={form.affiliate.data.messenger}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.websiteUrl)}
		<Input
			name="websiteUrl"
			label={$_('affiliateRegistrationData.websiteUrl')}
			required={isCustomQuestionRequired(formSettings.websiteUrl)}
			type={InputType.url}
			bind:value={form.affiliate.data.websiteUrl}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.promotionChannels)}
		<Input
			name="promotionChannels"
			label={$_('affiliateRegistrationData.promotionChannels')}
			max={255}
			required={isCustomQuestionRequired(formSettings.promotionChannels)}
			bind:value={form.affiliate.data.promotionChannels}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.audience)}
		<Input
			name="audience"
			label={$_('affiliateRegistrationData.audience')}
			max={255}
			required={isCustomQuestionRequired(formSettings.audience)}
			bind:value={form.affiliate.data.audience}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.currentTraffic)}
		<Input
			name="currentTraffic"
			label={$_('affiliateRegistrationData.currentTraffic')}
			max={255}
			required={isCustomQuestionRequired(formSettings.currentTraffic)}
			bind:value={form.affiliate.data.currentTraffic}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.expectedTraffic)}
		<Input
			name="expectedTraffic"
			label={$_('affiliateRegistrationData.expectedTraffic')}
			max={255}
			required={isCustomQuestionRequired(formSettings.expectedTraffic)}
			bind:value={form.affiliate.data.expectedTraffic}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.affiliateType)}
		<Select
			name="affiliateType"
			label={$_('affiliateRegistrationData.affiliateType')}
			options={[
				{ label: 'Content sites', value: 'Content sites' },
				{ label: 'Paid traffic', value: 'Paid traffic' },
				{ label: 'Review sites', value: 'Review sites' },
				{ label: 'Coupon sites', value: 'Coupon sites' },
				{ label: 'Bloggers', value: 'Bloggers' },
				{ label: 'Shopping comparison', value: 'Shopping comparison' },
				{ label: 'Email', value: 'Email' },
				{ label: 'Other', value: 'Other' },
			]}
			required={isCustomQuestionRequired(formSettings.affiliateType)}
			bind:value={form.affiliate.data.affiliateType}
		/>
	{/if}

	{#if isCustomQuestionVisible(formSettings.previousExperience)}
		<Input
			name="previousExperience"
			label={$_('affiliateRegistrationData.previousExperience')}
			max={255}
			required={isCustomQuestionRequired(formSettings.previousExperience)}
			bind:value={form.affiliate.data.previousExperience}
		/>
	{/if}

	{#each formSettings.customQuestions.filter( (question) => isCustomQuestionVisible(question.visibility), ) as question, i (i)}
		<CustomQuestionAnswerForm
			index={i}
			{question}
			bind:answer={form.affiliate.data.customQuestionAnswers[i].answer}
		/>
	{/each}
</FormContainer>

<div class="mb-10"></div>
